import React, { useRef } from 'react'
import styled  from 'styled-components'
import { categories } from '../data'
import {mobile} from "../responses"
import {Link} from "react-router-dom"

const Container=styled.div`
    height:70vh;
    flex:1;
    margin:3px;
    overflow: hidden;
    position:relative;
`
const Image=styled.img`
    width:100%;
    height:100%;
    object-fit:cover;
    ${mobile({height:"40vh"})};
    transition: transform .2s ;
`
const Info=styled.div`
    position:absolute;
    height:100%;
    width:100%;
    top:0%;
    left:0;
    display:flex;
    align-items:center;
    justify-content:center;
    flex-direction:column;
    font-size:20px;

    &:hover ${Image}{
        transform: scale(1.04);
    }
    `
    const Tittle=styled.h1`
    color:white;
    margin:1rem;
    /* font-weight: 900; */
    font-size: 30px;
    text-shadow:2px 2px 10px black;
`
const Button=styled.button`
    border:none;
    padding:10px;
    background-color:white;
    color:gray;
    cursor:pointer;
    font-weight:600;
`

const CategItems = ({item}) => {

    const ref=useRef()

    const handleMouseIn=(e)=>{
        ref.current.style.transform="scale(1.04)"        
    }

    const handleMouseOut=(e)=>{
        ref.current.style.transform="scale(1.00)"        
    }
  return (
    <Container>
        <Link to={`/products/${item.categ}`} >

       <Image ref={ref} style={item?.style} className='images' src={item.img}/>
       <Info onMouseEnter={handleMouseIn} onMouseLeave={handleMouseOut}>
            <Tittle>{item.title}</Tittle>
            <Link to={"/products"} >
                    <Button>
                    SHOP NOW
                    </Button>
                </Link>
       </Info>
        </Link>
      
    </Container>
  )
}


export default CategItems
